// cryptoLegacyCJ.ts
import CryptoJS from "crypto-js";

const KEY_ASCII = "e8ffc7e56311679f12b6fc91aa77a5eb";
const IV_ZERO = CryptoJS.enc.Hex.parse("00000000000000000000000000000000");

// Key is the UTF‑8 bytes of the ASCII string (not hex-decoded!)
const KEY_WORDS = CryptoJS.enc.Utf8.parse(KEY_ASCII);

export function decryptLegacyCJ(b64Cipher)  {
  try {
    const ct = CryptoJS.enc.Base64.parse((b64Cipher || "").replace(/\s+/g, ""));
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ct },
      KEY_WORDS,
      { iv: IV_ZERO, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
    );
    return CryptoJS.enc.Utf8.stringify(decrypted) || null;
  } catch {
    return null;
  }
}
